<!--  -->
<template>
    <section class=''>
        <el-select v-on="$listeners" v-bind="$attrs" popper-class="custom-select-popper " class="width100">
            <el-option v-for="item in options" :key="item.value" :label="item[configs.label]" :value="item[configs.value]"
                v-bind="item">{{ item[configs.text] }}
            </el-option>
        </el-select>
    </section>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    props: {
        options: {
            type: Array,
            default: () => { return {} },
        },
        configs: {
            type: Object,
            default: () => {
                return {
                    value: 'value',
                    label: 'label',
                    text: 'label'
                }
            }
        }
    },
    data() {
        //这里存放数据
        return {

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //方法集合
    methods: {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
$colorE8: #E8F4FF;
$color189: #1890FF;
$colorF0F: #F0F1F3;
$color1F2: #1F2329;

.width100 {
    width: 100%;
}

.custom-select-popper {
    .el-select-dropdown__item.selected {
        background-color: transparent;
        color: $color189;
    }

    .el-select-dropdown__item:hover,
    .el-select-dropdown__item:focus {
        background-color: $colorF0F ;
        color: $color1F2;
    }

    //    键盘上下
    .el-select-dropdown__item.hover {
        background-color: $colorE8 ;
        color: $color189;
    }

    // 鼠标

}</style>